import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';

import { APWarningNotification } from '../../utils';

import { dialogManagerActiveAtom } from '../../atoms';

import { JSX } from 'react';
import { DialogType } from './types';
import { showSnackbar } from 'components/shared';
import WarningDialog from 'components/shared/WarningDialog/WarningDialog';

const DialogManager = (): JSX.Element | null => {
  const [, setDialogState] = useRecoilState(dialogManagerActiveAtom);
  const { t } = useTranslation('common');
  const dialogState = useRecoilValue<{
    type: DialogType | null;
    open: boolean;
    data?: APWarningNotification;
    onSubmit: () => void;
    onCancel?: () => void;
  }>(dialogManagerActiveAtom);
  const { type, open, data, onSubmit, onCancel } = dialogState;
  const close = () => setDialogState({ ...dialogState, open: false });

  const messageArr = Object.entries({ ...data }).map(([, value]) => value); // Object to array of messages
  const messages = messageArr.map(({ translationKey, messages }) => ({
    title: t(translationKey),
    messages: messages.map(({ meta: { name, time } }) => `${name} - ${time}`)
  })); // Map translation key to localisation message

  if (type === undefined || type === null) return null;

  switch (dialogState.type) {
    case DialogType.WARNING:
      // The dialog decides whether a drop/connect the backend refused with
      // warnings goes through after all. A click on the backdrop must not take
      // that decision: to a planner it reads as dismissing a notice, and the
      // card then "pops back" for no visible reason. Escape and the close icon
      // still cancel, as in any confirmation dialog, but every cancel says so.
      return (
        <WarningDialog
          open={open}
          messages={messages}
          disableBackdropClick
          onSubmit={() => {
            onSubmit();
            close();
          }}
          onCancel={() => {
            if (typeof onCancel === 'function') onCancel();
            close();
            showSnackbar({
              severity: 'info',
              message: t('activityPlanning.changeNotApplied')
            });
          }}
        />
      );
    // case DialogType.SOME_OTHER_DIALOG: ...
    default:
      return null;
  }
};

export default DialogManager;
